import * as React from 'react'
import Modal from '../ui/Modal'
import { IActiveTripResponseV2, IProviderProductObject, ITripEdit } from '../../types'
import UIMessages from '../../utils/ui-messages'
import { Redirect } from 'react-router'
import { TripStatuses } from 'src/constants/trip-statuses'
import { MoonLoader } from 'react-spinners'

interface ICancelBillableProps {
  currentTripId: string
  currentTrip: IActiveTripResponseV2
  providerProduct: IProviderProductObject | null
  loading: boolean
  fetchProduct: (productId: string) => IProviderProductObject
  cancelBillable: (
    tripId: string,
    paymentRequired: boolean,
    tripPrice?: number,
    comment?: string,
    disableNotification?: boolean
  ) => Promise<any>
  close: () => void
  saveData: (params: ITripEdit) => Promise<any>
}

export const CancelBillableModal = (props: ICancelBillableProps) => {
  const [reason, setReason] = React.useState('')
  const [otherReason, setOtherReason] = React.useState('')

  const handleSelect = (event: any) => {
    setReason(event.target.value)
  }

  const handleOtherReasonUpdate = (event: any) => {
    setOtherReason(event.target.value)
  }

  const onSubmit = async (
    tripId: string,
    paymentRequired: boolean,
    tripPrice?: number,
    comment?: string,
    disableNotification?: boolean
  ) => {
    try {
      //Audit Trail
      const params: ITripEdit = {
        prevNotes: props.currentTrip.lastStatus
      }
      await props.saveData(params)
      await props.cancelBillable(tripId, paymentRequired, tripPrice, comment, disableNotification)
    } catch (e) {
      console.log('Problem manually completing trip')
    }
  }

  React.useEffect(() => {
    if (props.currentTrip.product.productId) {
      props.fetchProduct(props.currentTrip.product.productId)
    }
  }, [props.currentTrip.product.productId])

  if (props.providerProduct && props.providerProduct.pricing) {
    const price = props.providerProduct.pricing.cancellationPrice
    const formattedPrice = price ? (price / 100).toFixed(2) : 0

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-4 p2'>
            <span className='ModalAddTitle weight-300 mb1 h3 bold'>{UIMessages.cancelBillable.modalTitle}</span>
            <div className='mt1'>
              <p className='h4'>
                {props.providerProduct.name} cancellation price: <b>${formattedPrice}</b>
              </p>
              <span>{UIMessages.cancelBillable.reasonQuestion}</span>
              <div className='mt1' onChange={handleSelect}>
                {UIMessages.cancelBillable.cancelReasons.map((reason, i) => (
                  <div key={i}>
                    <label>
                      <input type='radio' name='reason' value={reason} />
                      <span>{reason}</span>
                    </label>
                  </div>
                ))}
              </div>
              <div className='mb1' onChange={handleOtherReasonUpdate}>
                <textarea className='col-12 p1 fit' value={otherReason} />
              </div>
              <div className='flex justify-between'>
                <button
                  type='button'
                  onClick={props.close}
                  className='CancelButton btn bg-white rounded font-light-grey mr2'
                >
                  {UIMessages.common.cancel}
                </button>
                <button
                  type='submit'
                  className='SubmitButton btn bg-green rounded font-white weight-300'
                  onClick={() => onSubmit(props.currentTripId, true, price, reason + ', ' + otherReason)}
                >
                  <span className='flex items-center'>
                    <div className='font-white'>{UIMessages.cancelBillable.submitButton}</div>
                    {props.loading ? (
                      <MoonLoader sizeUnit={'px'} size={20} color={'#405264'} loading={true} />
                    ) : (
                      <React.Fragment />
                    )}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
  return <div />
}



// WEBPACK FOOTER //
// ./src/components/trips/CancelBillableModal.tsx